import { FaCheckCircle, FaExclamationCircle } from 'react-icons/fa';
import { Loading } from '../loading';
import { colors } from '../../constants';

export const StateBadge = ({ state }) => {
  switch (state) {
    case 'active':
      return <Loading size="xs" />;
    case 'completed':
      return (
        <div
          style={{
            color: colors.green,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <FaCheckCircle />
        </div>
      );
    case 'error':
      return (
        <div
          style={{
            color: colors.red,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <FaExclamationCircle />
        </div>
      );
  }

  return <div>{state}</div>;
};
